module.exports = __webpack_public_path__ + "static/media/firebase.9e82f6f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/firebase.svg
// module id = 192
// module chunks = 0